import React from "react";

import './button.scss'

interface ButtonProps {
    type: 'outline' | 'fill',
    icon?: string,
    iconAlt?: string,
    iconWidth?: number,
    iconHeight?: number,
    iconPosition?: 'pre' | 'post',
    text?: string,
    onClick?: () => void,
    classNames?: string,
    disabled? : boolean,
    outlineIcon?: string,
    outlineHovericon?: string,
    forMobile?: boolean
}
const Button: React.FC<ButtonProps> = ({text, icon, iconPosition, type, onClick, classNames,iconAlt, iconWidth, iconHeight, disabled, outlineIcon, outlineHovericon, forMobile}) => {
    return (
        <button className={`custom_button ${type ?? ''} ${classNames ?? ''} ${disabled ? 'disabled' : ''} ${forMobile ? 'mobile-view' : ''}`} onClick={onClick} disabled={disabled} >
            <div className="custom_button_container">
                {
                    (icon || outlineIcon) && iconPosition === 'pre' ?
                        <>
                            <img width={iconWidth} height={iconHeight} className={`icon ${iconPosition} ${outlineIcon ? 'default' : ''}`} src={icon ?? outlineIcon} alt= {iconAlt ?? ''} />
                            {
                                outlineIcon ? 
                                <img width={iconWidth} height={iconHeight} className={`icon ${iconPosition} ${outlineIcon ? 'hover' : ''}`} src={outlineHovericon} alt= {iconAlt ?? ''} />
                                : null
                            }
                        </>
                        
                    : null
                }
                <p className="text">{text}</p>
                {
                    (icon || outlineIcon) && iconPosition === 'post' ?
                    <>
                            <img width={iconWidth} height={iconHeight} className={`icon ${iconPosition} ${outlineIcon ? 'default' : ''}`} src={icon ?? outlineIcon} alt= {iconAlt ?? ''} />
                            {
                                outlineIcon ? 
                                    <img width={iconWidth} height={iconHeight} className={`icon ${iconPosition} ${outlineIcon ? 'hover' : ''}`} src={icon ?? outlineIcon} alt= {iconAlt ?? ''} />
                                : null
                            }
                        </>
                    : null
                }

            </div>

        </button>
    )
}

export default Button;